import { useCallback, useRef } from 'react';

import { getProductsOrder } from './getProductsOrder';

export function useProductSortOrder(): () => Promise<(a: string, b: string) => number> {
	const productsOrderRef = useRef<string[] | undefined>(undefined);

	return useCallback(async () => {
		let productsOrder = productsOrderRef.current;
		if (productsOrder === undefined) {
			productsOrder = await getProductsOrder();
			productsOrderRef.current = productsOrder;
		}
		return (a: string, b: string) => {
			const indexA = productsOrder.indexOf(a);
			const indexB = productsOrder.indexOf(b);

			if (indexA === -1 || indexB === -1) {
				return 0;
			} else {
				return indexA - indexB;
			}
		};
	}, [productsOrderRef]);
}
